// cSpell:ignore rubrique rubriques Silae
import { RUBRIQUE_CODES } from "@/data/silae-rubriques";

export function findRubriqueLabel(code: string): string | undefined {
  for (const category of Object.values(RUBRIQUE_CODES)) {
    const rubrique = category.find((r) => r.code === code);
    if (rubrique) {
      return rubrique.label.length > 30
        ? rubrique.label.substring(0, 30) + "..."
        : rubrique.label;
    }
  }
  return undefined;
}
